import { PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_PROCESS_CLEAR_STATE } from "./constants";
import { productChangeOfAddressInitialState } from "./productChangeOfAddress2ndPhase";

const clear = (state: any) => {
	Object.assign(state, productChangeOfAddressInitialState());
};

const SET_PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_PROCESS = (state: any, payload: any) => {
	state.changeOfAddress2ndPhase = {
		...state.changeOfAddress2ndPhase,
		address: {
			...state.changeOfAddress2ndPhase.address,
			id: payload?.coverage?.addressId ?? "-1"
		},
		apartment: {
			...state.changeOfAddress2ndPhase.apartment,
			apartmentId: payload?.coverage?.apartmentId ?? "-1"
		},
		notes: payload?.notes ?? "",
		salesPerson: payload?.salesPerson ?? "",
		targetDate: payload?.targetDate ?? "",
		intermediateProduct: {
			...state.changeOfAddress2ndPhase.intermediateProduct,
			salesPerson: payload?.intermediateProduct?.salesPerson ?? "",
			targetDate: payload?.intermediateProduct?.targetDate ?? ""
		}
	};
};

const SET_CHANGE_OF_ADDRESS_PROCESS_2ND_PHASE_STATUS = (state: any, payload: string) => {
	state.status = payload;
};

const SET_CHANGE_OF_ADDRESS_PROCESS_2ND_PHASE_SHOPPING_CART_ID = (state: any, payload: string) => {
	state.shoppingCartId = payload;
};

const SET_CHANGE_OF_ADDRESS_PROCESS_2ND_PHASE_PRODUCT_SELECTED = (state: any, payload: string) => {
	state.selectedProduct = payload;
};

const SET_ORDER_CHANGE_OF_ADDRESS_2ND_PHASE = (state: any, payload: any) => {
	state.changeOfAddress2ndPhase = {
		...state.changeOfAddress2ndPhase,
		salesPerson: payload?.salesPerson ?? state.changeOfAddress2ndPhase.salesPerson,
		targetDate: payload?.targetDate ?? state.changeOfAddress2ndPhase.targetDate,
		notes: payload?.notes ?? state.changeOfAddress2ndPhase.notes
	};
};

export default {
	[PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_PROCESS_CLEAR_STATE]: clear,
	SET_PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_PROCESS,
	SET_CHANGE_OF_ADDRESS_PROCESS_2ND_PHASE_STATUS,
	SET_CHANGE_OF_ADDRESS_PROCESS_2ND_PHASE_SHOPPING_CART_ID,
	SET_CHANGE_OF_ADDRESS_PROCESS_2ND_PHASE_PRODUCT_SELECTED,
	SET_ORDER_CHANGE_OF_ADDRESS_2ND_PHASE
};
